export const NAME = 'customDevelopedDashboard';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;

        case 'CUSTOM_DEVELOPED_DASHBOARD__FETCH_SEGMENTS_DATA__END': {
            return {
                ...state,
                audienceSegments: action.payload.data,
            };
        }

        case 'CUSTOM_DEVELOPED__INIT_START': {
            return {
                ...state,
                isLoading: true,
            };
        }

        case 'CUSTOM_DEVELOPED__INIT_END': {
            return {
                ...state,
                isLoading: false,
                totalSegmentCount: action.payload.totalSegmentCount,
            };
        }
    }
}
